import { FIRMNESS_ENDPOINT, getFirmnessLevels } from '@src/service/firmness'
import { Firmness } from '@src/types/strapi'
import useSWR from 'swr'

export const useFirmness = () => useSWR<Firmness[]>(FIRMNESS_ENDPOINT, () => getFirmnessLevels())
